import React from 'react'
import { makeStyles, Link, Typography } from '@material-ui/core'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import {
  openNewTab,
  privacyPolicyUrl,
  termsOfUseUrl,
  cookiePolicyUrl,
} from '../../commons/website'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
  },
  fontSize: {
    fontSize: '16px',
    color: theme.palette.grey.morevertIcon + ' !important',
  },
  link: {
    fontSize: '12px !important',
    cursor: 'pointer',
    color: theme.palette.grey.morevertIcon + ' !important',
  },
  copyright: {
    fontSize: '11px',
    color: theme.palette.grey.intensive,
  },
  rootContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'wrap',
  },
  dot: { marginTop: '3px' },
}))

export default (props) => {
  const { locale } = useIntl()
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className="flex flex-col">
        <Typography className={classes.rootContainer}>
          <Link
            onClick={() => openNewTab(termsOfUseUrl)}
            className={classes.link}
          >
            <FormattedMessage id="login.termsOfService" />
          </Link>
          {locale === 'en' ? (
            <span className={clsx(classes.fontSize, classes.dot)}>&bull; </span>
          ) : (
            <br />
          )}
          <Link
            onClick={() => openNewTab(privacyPolicyUrl)}
            className={classes.link}
          >
            <FormattedMessage id="login.privacyPolicy" />
          </Link>
          {locale === 'en' ? (
            <span className={clsx(classes.fontSize, classes.dot)}>&bull; </span>
          ) : (
            <br />
          )}
          <Link
            onClick={() => openNewTab(cookiePolicyUrl)}
            className={classes.link}
          >
            <FormattedMessage id="login.cookiePolicy" />
          </Link>
        </Typography>
        <span className={classes.copyright}>
          <FormattedMessage
            id="ifyoucan.copyright"
            values={{ years: moment().format('YYYY') }}
          />
        </span>
      </div>
    </div>
  )
}
